import styled from 'styled-components'
import { themeColors } from 'components/charts/colors'
import {
  Card as RSCard, CardProps as RSCardProps,
  CardBody as RSCardBody, CardBodyProps as RSCardBodyProps,
} from 'reactstrap'
import colors from 'constants/colors'

export type CardProps = RSCardProps
export type CardBodyProps = RSCardBodyProps

export const CardTitle = styled.h5`
  font-family: Poppins;
  font-size: 22px;
  color: ${themeColors.dark};
  letter-spacing: 1.17px;
  font-weight: 500;
  margin-bottom: 0;
  margin-left: 8px;
  display: inline-block;
  padding-left: 5px;
  position: relative;
  top: 2px;
`

export const Card = styled(RSCard)`
  border-radius: 14px;
  border: 0;
  box-shadow: 0 12px 26px 0 rgba(23,23,33,0.05);
`

export const CardBody = styled(RSCardBody)`
  padding: 20px;
`

export const SecondaryCardTitle = styled.h5`
  font-family: Poppins;
  font-size: 36px;
  color: ${colors.primary};
  letter-spacing: 1.17px;
  font-weight: 600;
  margin-bottom: 0;
  margin-left: 2px;
`

export const SecondaryCardSubtitle = styled.p`
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  color: #FFC900;
  letter-spacing: 0.59px;
  margin-bottom: 0;
  text-transform: uppercase;
`

export const SecondaryCard = styled(RSCard)`
  background-color: #F5F6F8;
  border-radius: 14px;
  border: 0;
  box-shadow: 0 12px 26px 0 rgba(23,23,33,0.05);

  svg {
    color: ${colors.primary};
  }
`

export const SecondaryCardBody = styled(RSCardBody)`
  padding: 20px;
`
